export const TOAST_SAFETY_OFFSET = 100 // it's offset to render box-shadow correctly (the toastify adds "overflow: hidden" to the container)
